const CATEGORY_PAGE_REFERRER = 'category-page'
const SIMPLEX_PAGE_REFERRER = 'simplex-page'
const SEARCH_BY_IMAGE_REFERRER = 'search-by-image'

type ElementWithDataset = {
  dataset: {
    page: string
  }
}

type ElementWithContent = {
  content?: string
}

const HAS_SIMPLEX_PAGE_META_TAG = Boolean(
  (
    document.querySelector(
      'meta[name="simplex-page"]'
    ) as unknown as ElementWithContent
  )?.content
)

export const getSearchFeature = () => {
  const value = new URLSearchParams(window.location.search).get(
    'search_feature'
  )
  return value ? value.trim() : null
}

const SEARCH_FEATURE = getSearchFeature()

const HAS_SEARCH_FEATURE_PARAM = !!SEARCH_FEATURE

const IS_SEARCH_BY_IMAGE =
  HAS_SEARCH_FEATURE_PARAM && SEARCH_FEATURE === SEARCH_BY_IMAGE_REFERRER

const IS_CATEGORY =
  (document.querySelector('[data-page]') as unknown as ElementWithDataset)
    ?.dataset.page === 'category'

const IS_SIMPLEX = document.location.href.includes('indexa_id')

export {
  CATEGORY_PAGE_REFERRER,
  IS_CATEGORY,
  IS_SIMPLEX,
  HAS_SIMPLEX_PAGE_META_TAG,
  SIMPLEX_PAGE_REFERRER,
  HAS_SEARCH_FEATURE_PARAM,
  SEARCH_FEATURE,
  IS_SEARCH_BY_IMAGE
}
